import React from "react";
import Layout from "../components/Layout";
import { Link, PageProps } from "gatsby";
import { FunctionComponent } from "react";
import { RichText } from "prismic-reactjs";
import styled from "styled-components";
import ArticleWidget from "../components/ArticleWidget";
import linkResolver from "../utils/linkResolver";


const ArticleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  & > * {
    margin-bottom: 50px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;

const PageButton = styled(Link)`
  border-radius: 5px;
  background-color: ${props => props.theme.colors.primary};
  //color:${props => props.theme.colors.primary};
  color: white;
  padding: 5px 10px;
  
  &:hover {
      color:${props => props.theme.colors.secondary};

  }

`;

const Page = styled.div`
  border-radius: 5px;
  background-color: ${props => props.theme.colors.primary};
    //color:${props => props.theme.colors.primary};
  color: white;
  padding: 5px 10px;
`

const PageButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
  
  * {
    margin: 15px;
  }
`;

interface CategoryPageProps extends PageProps {
    data: GatsbyTypes.CategoryQuery;
    pageContext: {
        pageNumber: number;
        articles: { node: GatsbyTypes.PRISMIC_Article }[];
        hasNextPage: boolean;
        category?: string;
    }
}

const CategoryPage: FunctionComponent<CategoryPageProps> = ({ data, pathContext, pageContext }) => {

    const previousLink = () => {
        if (pageContext.category && pageContext.pageNumber === 2) {
            return '/kategoria/'+pageContext.category
        } else if (pageContext.pageNumber === 2) {
            return '/'
        } else {
            return `${pageContext.category ? '/kategoria/'+pageContext.category : ''}/strona/${pageContext.pageNumber - 1}`
        }
    }


    return (
        <Layout>
            <Wrapper>
                <ArticleWrapper>
                    {!!pageContext.articles &&
                    pageContext.articles.map(article => {
                        if (!article) return null;
                        return (
                            <ArticleWidget
                                key={article.node._meta.uid}
                                title={RichText.asText(article.node.title)}
                                imageFluid={article.node.imageSharp?.childImageSharp?.fluid}
                                description={RichText.asText(article.node.description)}
                                link={linkResolver(article.node._meta)}
                                tags={article.node._meta.tags}
                                date={article.node._meta.firstPublicationDate}
                                category={
                                    ((article.node
                                        .category as unknown) as GatsbyTypes.PRISMIC_Category)?.name
                                }
                            />
                        );
                    })}
                </ArticleWrapper>
                <PageButtonsWrapper>
                    {pageContext.pageNumber > 1 &&
                    <PageButton to={previousLink()}> Poprzednia strona</PageButton>}
                    <Page>{pageContext.pageNumber}</Page>
                    {pageContext.hasNextPage &&
                    <PageButton to={`${pageContext.category ? '/kategoria/'+pageContext.category : ''}/strona/${pageContext.pageNumber + 1}`}>Następna strona</PageButton>}
                </PageButtonsWrapper>
            </Wrapper>
        </Layout>
    );
};

export default CategoryPage;
